export const PLACEHOLDER = "Escribe aquí el motivo de la solicitud del rechazo";
export const SEND = "Enviar";
